import { useNotifier } from '@cbgms/base/notifier'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { Grid } from '@mui/material'
import WholesalerForm, { FormValues } from '../components/Form'
import { useMutateCreateWholesaler } from '../hooks/useMutateCreateWholesaler'
import { useMutateWholesalerService } from '../hooks/useMutateWholesalerService'
import WholesalerCatalogContainer from '../components/catalog/WholesalerCatalogContainer'
import { CountryCode } from '@carsys/enums/country-code'
import { CmsSystem, OrderSystem, TicketSystem } from '@cbgms/api'

export const NewWholesaler = () => {
  const { t } = useTranslation()
  const notifier = useNotifier()
  const h = useHistory()

  const mutateCreateWholesaler = useMutateCreateWholesaler()
  const mutateWholesalerService = useMutateWholesalerService()

  const onSubmit = async (values: FormValues) => {
    const { Country, OrderSystem, ServiceToggles, ServiceConfig } = values

    // Transform ServiceToggles and ServiceConfig form values to API compatible request body
    const services = Object.keys(ServiceToggles).map(key => ({ Service: key, Active: ServiceToggles[key], Config: ServiceConfig[key] }))

    try {
      const { UUID } = await mutateCreateWholesaler.mutateAsync({ wholesaler: values })
      values.UUID = UUID
      await mutateWholesalerService.mutateAsync({ UUID, country: Country, orderSystem: OrderSystem, services })
    } catch (e) {
      notifier.error(t('global.error'))
    }

    return values
  }

  const onSubmitSuccess = (formValues: FormValues) => {
    notifier.success(t('global.successfully_saved'))
    h.push(`/wholesale/edit/${formValues.UUID}`)
  }

  const initialValues: FormValues = {
    UUID: '',
    HaynesProDistributorUUID: '',
    Country: CountryCode.ZZ,
    IsActive: false,
    LogoURL: '',
    Name: '',
    TicketURL: '',
    CMSSystem: CmsSystem.NA,
    IFrameURL: '',
    CMSURL: '',
    SupportEmail: '',
    SupportPhoneNumber: '',
    SupportFullAddress: '',
    TicketSystem: TicketSystem.NA,
    TermsAndConditionsURL: '',
    OrderSystemSettings: {},
    OrderSystem: OrderSystem.NA,
    ServiceConfig: {},
    ServiceToggles: {},
    HideLocalStock: false,
    HideTotalStock: false,
    OrderEmailAcknowledgementWholesalerEmailAddress: '',
    OrderEmailAcknowledgementWholesalerEnabled: false,
    AvailableForPortal: true
  }

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <WholesalerForm initialValues={initialValues} onSubmit={onSubmit} onSubmitSuccess={onSubmitSuccess} />
      </Grid>
      <Grid item xs={12}>
        <WholesalerCatalogContainer />
      </Grid>
    </Grid>
  )
}

export default NewWholesaler
